export default __webpack_public_path__ + "static/media/WVBCoin.24bd1f8d.svg";